import {Component, EventEmitter, Output} from '@angular/core';

@Component({template:''})
export class MxGridRowsChanged {
    @Output() onRowsChanged: EventEmitter<Array<any>> = new EventEmitter<Array<any>>();

    public rowsChanged(rows: Array<any>): void {
        this.onRowsChanged.emit(rows);
    }
}
